export default {
    header: 'Activity Log',
    searchText: 'Search by Employee ID / Username',
    search: 'Search',
    dateTime: 'Date & Time',
    employeeId: 'Employee ID',
    userName: 'Username',
    change: 'Change',
    menu: 'Menu',
    action: ''
}
